var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-lg modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c(
                  "div",
                  {
                    staticClass: "modal-header",
                    class: { "bg-danger": _vm.canDelete },
                  },
                  [
                    _c("h5", { staticClass: "modal-title" }, [
                      _vm._v("Delete attribute"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close",
                        attrs: { type: "button" },
                        on: { click: _vm.close },
                      },
                      [_vm._v("×")]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  !_vm.initialized
                    ? _c("h4", [
                        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                        _vm._v(
                          " Checking dependencies...\n                    "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.canDelete
                    ? _c("div", [
                        _c("h4", [
                          _vm._v("Are you sure you want to delete this list?"),
                        ]),
                        _vm._v(" "),
                        _c("p", [
                          _vm._v("You are about to delete '"),
                          _c("strong", [_vm._v(_vm._s(_vm.name))]),
                          _vm._v("'. This can't be undone."),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.canDelete
                    ? _c(
                        "div",
                        [
                          _c(
                            "div",
                            {
                              staticClass: "alert alert-danger text-dark",
                              attrs: { role: "alert" },
                            },
                            [
                              _c("h5", { staticClass: "alert-heading" }, [
                                _vm._v("Cannot delete this list"),
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  "\n                                The list '"
                                ),
                                _c("strong", [_vm._v(_vm._s(_vm.name))]),
                                _vm._v("' is used in "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.dependenciesCount)),
                                ]),
                                _vm._v(
                                  " places.\n                                To delete this list, first remove it from where it is used.\n                            "
                                ),
                              ]),
                            ]
                          ),
                          _vm._v(" "),
                          _c("AlternativesViewDependenciesList", {
                            attrs: {
                              initialized: _vm.initialized,
                              reports: _vm.reports,
                              lists: _vm.lists,
                              estimationsSurveys: _vm.estimationsSurveys,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _vm.canDelete
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-danger",
                          attrs: { type: "button" },
                          on: { click: _vm.deleteList },
                        },
                        [_vm._v("Delete")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Cancel")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }